import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/*istanbul ignore file*/
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AddPaymentMethodButton, AddPaymentMethodButtonContainer, MopList, StyledAccordion, PaddedContainer } from './styled';
import { setModeClickHandler } from '../../DefaultMopView/helpers';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { AppMode } from '../../../redux/AppModeState/AppModeState.types';
import { DataTestAttributes } from '../../../constants/DataTestAttributes';
import { getString } from '../../../constants/Strings';
import { CardTypes } from '../../../constants/PaymentTypes';
import { Referrer } from '../../../constants/AppConstants';
import { doFireStatusUpdate, sendRioEventCallback } from '../../../utils/CallbackUtils';
import { ElementType, PaymentMethodsCommandNames, sendRioEvent, SpecType, StatusTypes, SubType } from '@chegg/commerce-utils';
import MopListItem from './MopListItem';
import MopDetailsItem from './MopDetailsItem';
import { configSelector } from '../../../redux/ConfigState/ConfigState.selectors';
import { paymentMethodsSelector, selectedMopSelector } from '../../../redux/MopOnFileState/MopOnFileState.selectors';
import { resetRecurlyForm } from '../../../redux/PaymentState/helpers/resetForm';
import { getPaymentFieldLabelText } from '../../PaymentForm/helpers';
import { PaymentFormDataFields } from '../../UserAddress/constants';
import { saveConfigs } from '../../../redux/ConfigState/ConfigState.actions';
import { isEmpty } from '@chegg/utils';
import { setSelectedMop } from '../../../redux/MopOnFileState/MopOnFileState.actions';
import { PlusIcon } from '@chegg-ui/theme';
var MopListView = function MopListView(props) {
  var _paymentMethods$;
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    activeTabIndex = _useState2[0],
    setActiveTabIndex = _useState2[1];
  var config = useAppSelector(configSelector);
  var selectedMop = useAppSelector(selectedMopSelector);
  var paymentMethods = useAppSelector(paymentMethodsSelector);
  var _useState3 = useState(selectedMop.cardId),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedPaymentMethodId = _useState4[0],
    setSelectedPaymentMethodId = _useState4[1];
  var rioNamespace = config.rioNamespace,
    paymentForm = config.paymentForm,
    referrer = config.referrer;
  var dispatch = useDispatch();
  var mode = props.mode;
  var multipleMop = paymentMethods.length > 1;
  var primaryMop = paymentMethods[0];
  var backupMop = (_paymentMethods$ = paymentMethods[1]) !== null && _paymentMethods$ !== void 0 ? _paymentMethods$ : undefined;
  useEffect(function () {
    doFireStatusUpdate([{
      status: StatusTypes.SUCCESS,
      command: PaymentMethodsCommandNames.MOP_SELECTED,
      payload: {
        data: selectedMop
      }
    }]);
  }, [selectedMop]);
  useEffect(function () {
    //Rio logging: Log all of users payment methods
    if (paymentMethods.length > 0) {
      paymentMethods.forEach(function (paymentMethod) {
        var cardType = paymentMethod.type;
        if (!cardType && paymentMethod.accountType === CardTypes.PAYPAL) {
          // in case of paypal, check for accountType
          cardType = 'paypal';
        } else if (!cardType && paymentMethod.accountType === CardTypes.VENMO) {
          // in case of venmo, check for accountType
          cardType = 'venmo';
        }
        sendRioEvent({
          info: getString('APP.RIO.EVENTS.MOP_LOADED'),
          specType: SpecType.COMPONENT_VIEW,
          subType: SubType.COMPONENT,
          callback: sendRioEventCallback,
          namespace: rioNamespace,
          value: cardType,
          force: false
        });
      });
    }

    // If User has multiple mop, show List of mops directly
    if (multipleMop && mode === AppMode.DEFAULT_MOP) {
      setModeClickHandler(AppMode.LIST_MOPS, AppMode.DEFAULT_MOP, dispatch);
    }
  }, [paymentMethods]);

  // In checkout pages (i.e. exclude myAccount payments page), disable caret and orange border for selectedMOP
  var isCheckoutPage = [Referrer.DCO, 'SCO', Referrer.ONE_CLICK].includes(referrer !== null && referrer !== void 0 ? referrer : '');
  var isMyAccountPage = referrer === Referrer.MY_ACCOUNT;
  var addPaymentMethodClickHandler = function addPaymentMethodClickHandler(e) {
    e.preventDefault();

    //Rio logging: When user clicks on Add Payment Method CTA
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.EL_NAME.ADD_PAYMENT_METHOD_CTA_CLICKED'),
      specType: SpecType.INTERACTION,
      subType: SubType.CLICK,
      elementType: ElementType.BUTTON,
      callback: sendRioEventCallback,
      namespace: rioNamespace
    });
    setModeClickHandler(AppMode.ADD, mode, dispatch);
    dispatch(saveConfigs({
      isNewMopAddingToMopList: true
    }));
    resetRecurlyForm(dispatch);
  };
  var selectPaymentMethodClickHandler = function selectPaymentMethodClickHandler(mop, e) {
    e.preventDefault();
    setSelectedPaymentMethodId(mop.cardId);
    dispatch(setSelectedMop({
      mop: mop
    }));
  };
  var selectedMopIndex = paymentMethods.findIndex(function (paymentMethod) {
    return paymentMethod.cardId === selectedPaymentMethodId;
  });
  return !isEmpty(selectedMop) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MopList, {
    "data-test": DataTestAttributes.MOP_LIST
  }, /*#__PURE__*/React.createElement(StyledAccordion, {
    tabs: paymentMethods.map(function (mop) {
      var cardId = mop.cardId;
      return {
        header: /*#__PURE__*/React.createElement(PaddedContainer, null, /*#__PURE__*/React.createElement(MopListItem, {
          mop: mop,
          key: cardId,
          rioNamespace: rioNamespace,
          onClick: function onClick(e) {
            return selectPaymentMethodClickHandler(mop, e);
          },
          isCheckoutPage: isCheckoutPage
        })),
        panel: /*#__PURE__*/React.createElement(MopDetailsItem, {
          mop: mop,
          isMultipleMop: multipleMop,
          backupMop: backupMop,
          primaryMop: primaryMop,
          onChangeIndex: setActiveTabIndex,
          onClick: function onClick(e) {
            return selectPaymentMethodClickHandler(mop, e);
          }
        })
      };
    }),
    activeTabIndex: isCheckoutPage ? -1 : activeTabIndex // set to -1 to make the accordion fully collapsed at all times
    ,
    onChangeIndex: setActiveTabIndex,
    size: "xl",
    id: "mop-list-accordion",
    "data-test": "mop-list-accordion",
    disabled: isCheckoutPage,
    isSelected: (isCheckoutPage || !isMyAccountPage) && selectedPaymentMethodId === selectedMop.cardId,
    selectedMopIndex: selectedMopIndex
  }), /*#__PURE__*/React.createElement(AddPaymentMethodButtonContainer, null, /*#__PURE__*/React.createElement(AddPaymentMethodButton, {
    "data-test": DataTestAttributes.ADD_PAYMENT_METHOD_LINK,
    onClick: addPaymentMethodClickHandler
  }, /*#__PURE__*/React.createElement(PaddedContainer, null, /*#__PURE__*/React.createElement(PlusIcon, {
    size: "medium"
  }), /*#__PURE__*/React.createElement("span", {
    className: "add-payment-method-description"
  }, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.ADD_PAYMENT_METHOD) || getString('APP.MOPONFILE.ADD.PAYMENT.METHOD'))))))) : null;
};
export default MopListView;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/Recurly/MopListView/MopListView.js
// module id = 4635
// module chunks = 11